import '../styles/bootstrap.scss';

window.flashMessage = async (...args) => {
	const { flashMessage } = await import('./components/flashMessage.js');
	return flashMessage(...args);
};
